export default "__VITE_ASSET__BoGb4MA4__"